import { LOCATION_CHANGE } from 'connected-react-router';

const initialState = {
  menuOpen: false,
  statusBarOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_MENU':
      return { ...state, menuOpen: !state.menuOpen, statusBarOpen: false };
    case 'CLOSE_MENU':
      return { menuOpen: false };
    case 'TOGGLE_STATUS_BAR':
      return { ...state, statusBarOpen: !state.statusBarOpen };
    case LOCATION_CHANGE:
      return { ...state, menuOpen: false };
    default:
      return state;
  }
};

export const toggleMenu = () => dispatch => dispatch({ type: 'TOGGLE_MENU' });
export const toggleStatusBar = () => dispatch =>
  dispatch({ type: 'TOGGLE_STATUS_BAR' });



// WEBPACK FOOTER //
// ./src/features/DefaultLayout/reducer.js